// What a reviewer does to the open product — approves it, rejects it, sends it back with what to change, takes a
// change set in or out — reaches the dialog while it is open (aldoo-na realtime: /rt/submissions, the product's
// organization's room, vendor-submissions broadcast). The product is read again: whole when nothing waits to be
// saved, else only its review state (the status, what was marked, the change set), so an edit in progress stays.
import useSubmissionEvents from "../../../Vendor/useSubmissionEvents"
import { LoadRawProduct } from "../../../AdminShared/api"

// what the review owns of a product (catalog product-raw)
const REVIEW_FIELDS = ["publishStatus", "lastReview", "reviewChange", "reviewChanges"]

export default function useReviewSync(editor) {
  const pid = editor?.product?.pid || null
  const publisher = editor?.product?.publisher
  const orgId = publisher ? String(publisher?._id || publisher) : null
  useSubmissionEvents({
    orgId,
    enabled: !!pid && !!orgId,
    events: ["submissions:product-review", "submissions:decision"],
    onEvent: async (notice) => {
      if (!pid || notice.pid !== pid) return
      if (!editor.dirty) return editor.reload?.()
      const res = await LoadRawProduct(pid).catch(() => null)
      const content = res?.content
      if (!content) return
      for (const field of REVIEW_FIELDS) editor.adopt(field, content[field] ?? null)
    },
  })
}
